import { Instagram, Music2, Facebook, Youtube, Mail } from "lucide-react";
import { useLocation } from "react-router-dom";

const openCookies = () => window.dispatchEvent(new Event("croclab-open-cookies"));

const NAV_LINKS = [
  { label: "Inicio", href: "#inicio", id: "inicio" },
  { label: "Carta", href: "#carta", id: "carta" },
  { label: "Locales", href: "#locales", id: "locales" },
  { label: "Nosotros", href: "#nosotros", id: "nosotros" },
  { label: "Contacto", href: "#contacto", id: "contacto" },
  { label: "Catering", href: "/catering", id: "catering", route: true },
];

const LEGAL_LINKS = [
  { label: "Aviso legal", href: "/aviso-legal", id: "aviso-legal" },
  { label: "Privacidad", href: "/privacidad", id: "privacidad" },
  { label: "Cookies", href: "/cookies", id: "cookies" },
  { label: "Alérgenos", href: "/alergenos", id: "alergenos" },
];

const SOCIALS = [
  {
    icon: Instagram,
    label: "Instagram",
    href: "https://www.instagram.com/croclab.es",
    id: "instagram",
  },
  {
    icon: Music2,
    label: "TikTok",
    href: "https://www.tiktok.com/@croc.lab",
    id: "tiktok",
  },
  {
    icon: Facebook,
    label: "Facebook",
    href: "https://www.facebook.com/share/1GiyxjfyjM/?mibextid=wwXIfr",
    id: "facebook",
  },
  {
    icon: Youtube,
    label: "YouTube",
    href: "https://www.youtube.com/@CrocLabofficial",
    id: "youtube",
  },
];

const Footer = () => {
  const { pathname } = useLocation();
  const base = pathname === "/" ? "" : "/";
  return (
  <footer data-testid="site-footer" className="bg-brand-charcoal text-white">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14 md:py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
      <div>
        <a href={`${base}#inicio`} data-testid="footer-logo-link" className="flex items-center gap-3" aria-label="CROC LAB - Ir al inicio">
          <img src="/brand/croc-mascot.png" alt="Mascota de CROC LAB" className="h-12 w-12" />
          <span className="font-display font-bold text-2xl tracking-tight">
            CROC <span className="text-brand-pink">LAB</span>
          </span>
        </a>
        <p className="mt-4 text-sm text-white/60 leading-relaxed max-w-xs">
          La vida es Croc. Un nuevo concepto de comida nacido en Valencia:
          crocca por fuera, brutal por dentro.
        </p>
        <a
          data-testid="footer-email-link"
          href="mailto:croclab.valencia@gmail.com"
          className="mt-4 inline-flex items-center gap-2 text-sm text-white/70 hover:text-brand-pink transition-colors"
        >
          <Mail className="w-4 h-4 text-brand-pink" aria-hidden="true" />
          croclab.valencia@gmail.com
        </a>
      </div>
      <nav aria-label="Navegación del pie de página">
        <p className="text-sm font-semibold uppercase tracking-widest text-white/40">Navegación</p>
        <ul className="mt-4 space-y-3">
          {NAV_LINKS.map((link) => (
            <li key={link.id}>
              <a
                data-testid={`footer-nav-link-${link.id}`}
                href={link.route ? link.href : `${base}${link.href}`}
                className="text-sm text-white/70 hover:text-brand-pink transition-colors"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>
      <div>
        <p className="text-sm font-semibold uppercase tracking-widest text-white/40">Síguenos</p>
        <div className="mt-4 flex gap-3">
          {SOCIALS.map((social) => (
            <a
              key={social.id}
              data-testid={`footer-social-${social.id}`}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={social.id === "youtube" ? "Croc Lab on YouTube" : `${social.label} de CROC LAB (se abre en una pestaña nueva)`}
              className="w-11 h-11 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-pink transition-colors"
            >
              <social.icon className="w-5 h-5" aria-hidden="true" />
            </a>
          ))}
        </div>
        <p className="mt-4 text-sm text-white/50">@croclab.es · @croc.lab · @CrocLabofficial</p>
      </div>
      <div>
        <p className="text-sm font-semibold uppercase tracking-widest text-white/40">Legal</p>
        <ul className="mt-4 space-y-3">
          {LEGAL_LINKS.map((link) => (
            <li key={link.id}>
              <a
                data-testid={`footer-legal-link-${link.id}`}
                href={link.href}
                className="text-sm text-white/70 hover:text-brand-pink transition-colors"
              >
                {link.label}
              </a>
            </li>
          ))}
          <li>
            <button
              data-testid="footer-cookies-config-button"
              onClick={() => window.dispatchEvent(new Event("croclab-open-cookies"))}
              className="text-sm text-white/70 hover:text-brand-pink transition-colors"
            >
              Configurar cookies
            </button>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
        <p data-testid="footer-copyright" className="text-xs text-white/50">
          © 2026 CROC LAB · Todos los derechos reservados
        </p>
        <a
          data-testid="footer-address-link"
          href="https://maps.app.goo.gl/3ZcPNSGucypFjynt5"
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs text-white/50 hover:text-brand-pink transition-colors"
        >
          C/ del Dr. Romagosa 10, Ciutat Vella, 46002 València
        </a>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
